/*
    generate by magix-combine@3.6.4: https://github.com/thx/magix-combine
    author: kooboy_li@163.com
    loader: webpack
 */

var dialog = Magix.addView("@ali/cell-dialog@0.0.17",require("@ali/cell-dialog@0.0.17"));;

var Util = {};

var webp = function () {
  var cblist = [];
  var state;

  if (/(iPad|iPod|iPhone|MSIE[\s\d\.]+);/i.test(navigator.userAgent)) {
    state = 0;
  } else {
    var onComplate = function onComplate(s) {
      state = !!s;
      for (var i = 0; i < cblist.length; i++) {
        cblist[i](state);
      };
    };
    var img = new Image();
    img.onload = function () {
      onComplate(1);
    };
    img.onerror = function () {
      onComplate(0);
    };
    img.src = "data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAgA0JaQAA3AA/vuUAAA=";
  }
  return function (cb) {
    if (typeof cb == "function") {
      typeof state != "undefined" ? cb(state) : cblist.push(cb);
    }
  };
}();
if (window._WEBP === void 0) {
  webp(function (state) {
    window._WEBP = state;
  });
}

// 扩展安全参数
// http://gitlab.alibaba-inc.com/sd/ctlv/wikis/home
Util.safe = function () {
  window.C_T_L = window.ctl;
  var client = window.ctl; // && window.ctl.noConflict() || {}
  client && client.config && client.config();
  return client;
}();

Util.accPlus = function (arg1, arg2) {
  var r1, r2, m, n;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2)); //last modify by deeka //动态控制精度长度
  n = r1 >= r2 ? r1 : r2;
  return ((arg1 * m + arg2 * m) / m).toFixed(n);
};

Util.dialog = function (params) {
  if (!$.isPlainObject(params)) {
    params = {
      content: params
    };
  }

  dialog.create({
    options: {
      pos: 'top',
      animated: 'slideInRight',
      content: params.msg,
      show: true
    }
  });
};

Util.mtop = function (url, data, callback, extendParams, version) {
  if (!window.lib && !window.lib.mtop) {
    alert('need mtop lib js in page');
    return;
  }
  var requestData = {
    "api": url,
    "v": version || "1.0",
    "AntiCreep": true,
    "data": data,
    "dataType": 'jsonp',
    "type": "GET",
    "ecode": '0'
  };
  if (extendParams) {
    $.extend(requestData, extendParams);
  }
  // 优先使用东溟那边的mtop,会带上监控，否则使用普通的
  if (window.MM_MTOP) {
    window.MM_MTOP.send(requestData, function (res) {

      var data = res.data;
      if (data.model) data = data.model; // 后端mock数据有问题，先临时处理

      // console && console.log('requestData' + JSON.stringify(data))

      callback(null, data);
      // callback({})
    }, function (error) {

      // console && console.log('requestDataerror' + JSON.stringify(error))

      var message = error;
      var errorCode = '';
      if (error && error.ret) {
        message = error.ret[0].split('::')[1] || '';
        errorCode = error.ret[0].split('::')[0];
      }

      // 未登录直接跳转登录
      if (errorCode === 'FAIL_SYS_SESSION_EXPIRED' || errorCode === 'ERR_SID_INVALID') {
        lib.login.goLogin();
        return;
      }
      if (data.defaultErrorhandle) {

        message = message || 'error';
        Util.dialog(message);
        return;
      }
      callback(error);
    });
  } else {
    lib.mtop.request(requestData, function (res) {
      var code = res.ret[0].split('::')[0];
      var success = code === 'SUCCESS';
      if (!success) {
        // res.code = code
        callback(res);
        if (data.defaultErrorhandle) Util.toast(res);
      } else {
        callback(null, res.data);
        //其他代码执行引起的错误
      }
    });
  }
};

Util.joinParams = function (obj) {
  var res = [],
      s = function s(k, v) {
    var k = encodeURIComponent(k),
        v = encodeURIComponent(v);
    if (k || v) {
      res.push(k + (v == "" ? "" : "=" + v));
    }
  };
  for (var k in obj) {
    var v = obj[k];
    if (v && v.constructor == Array) {
      for (var i = 0, len = v.length; i < len; i++) {
        s(k, v[i]);
      }
    } else {
      s(k, v);
    }
  }
  return res.join("&");
};

Util.parseParams = function (str) {
  var p = {};
  if (str) {
    for (var i = 0, s, d = str.split(/&+/), len = d.length; i < len; i++) {
      if (s = d[i]) {
        var k = Util.decodeURIComponent(s.replace(/=.*/, "")),
            v = Util.decodeURIComponent(s.replace(/(.*?=)|(.*)/, ""));
        if (k || v) {
          if (k in p) {
            if (typeof p[k] == "string") p[k] = [p[k]];
            p[k].push(v);
          } else {
            p[k] = v;
          }
        }
      }
    }
  }
  if (p.pid && $.isArray(p.pid)) {
    p.pid = p.pid[0];
  }
  return p;
};

// %dd 这样就会报 URI malformed 异常
Util.decodeURIComponent = function (str) {
  try {
    return decodeURIComponent(str);
  } catch (e) {
    return "";
  }
};

Util.searchObj = function () {
  return Util.parseParams(window.location.search.replace(/^\?+/, ""));
}();

Util.isLogin = function () {
  if (!lib.login) return false;
  return lib.login.isLogin();
};

Util.appendParams = function (url, params) {
  var str = Util.joinParams(params);
  if (url.indexOf('?') !== -1) {
    url += '&' + str;
  } else {
    url += '?' + str;
  }
  return url;
};

Util.fixDomain = function (url) {
  // 针对预发环境作出处理
  // h5.m.taobao.com  => wapp.m.taobao.com  并且加上 systype= wapa
  // mo.m.taobao.com => 加上  systype= wapa & preview= 1
  // 并且全部改成http
  if (!/(h5|wapp|mo|mos)\.m\.taobao\.com/.test(url)) return url;

  var env = 'online';
  if (location.href.indexOf('wapp') !== -1 || location.href.indexOf('preview=1') !== -1) {
    env = 'pre';
  }

  if (env !== 'online') {
    url = url.replace('h5.m.taobao.com', 'wapp.m.taobao.com');
    url = url.replace('https', 'http');

    url = Util.appendParams(url, {
      'preview': '1'
    });
  }

  if (Util.searchObj.systype) {
    // systype 做透传
    url = Util.appendParams(url, {
      'systype': Util.searchObj.systype
    });
  }

  return url;
};

Util.sync = function (url, params, sucessfn, errfn) {
  $.ajax({
    url: Util.appendParams(url, params),
    dataType: 'jsonp',
    jsonp: 'cb',
    data: '',
    success: function success(data, status, xhr) {
      if (data) {
        sucessfn && sucessfn(data);
      } else {
        sucessfn && sucessfn(null, data);
      }
    },
    error: function error(xhr, msg) {
      errfn && errfn(msg);
    }
  });
};

module.exports = Util;


//////////////////
// WEBPACK FOOTER
// ./app/lib/Util.js
// module id = 0
// module chunks = 1 2